import React from 'react';
import CommonService from '../../../../services/commonService';
import getHeaderLinks from '../../functions/getHeaderLinks';
import getIcons from '../../functions/getIcons/getIcons';

const Header3 = () => {
  const operator = CommonService.getLocal('op');
  return (
    <div className="themes-header-3 ">
      <div className={`${window.location.pathname === '/' ? 'header3' : ''} new-container`} >
        <div className="theme3-header-left">
          <a href='/'>
            <img
              src={getIcons('headerLogo', operator)}
              alt="logo"
              className="logo"
              id="main-logo"
              // alt={this.props.t('TRANSLATIONS.VIATUR_MAIN_LOGO')}
              style={{
                width: operator.header_logo_width, margin: '10px 0',
                height: 'auto'
              }}
            />
          </a>
        </div>


        <style>
          .nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
          margin-top:182px
          {'}'}

        </style>


        {window.location.pathname == '/' &&
          <div className="theme3-header-right">
            {getHeaderLinks().map((val, i) => {
              return (
                // <li >
                <a
                  className="header_link"
                  style={{
                    
                    // color: operator.text_color,

                  }}
                  href={val.url}
                >
                  {val.label}
                </a>
                // </li>
              );
            })
            }
          </div>
        }

      </div>
    </div>
  );
}

export default Header3 


// WEBPACK FOOTER //
// ./src/features/themes/common/header/Header3.js